import InfoFieldGrid from './InfoFieldGrid';
export default InfoFieldGrid;
export { default as InfoFieldGrid } from './InfoFieldGrid';